export const ROLES = {
  ADMIN: "ADMIN",
  SALES: "SALES",
  AGENT: "AGENT",
};


/*
|--------------------------------------------------------------------------
| ROLE HELPERS
|--------------------------------------------------------------------------
*/

export const hasRole = (user, role) => {
  if (!user || !role) {
    return false;
  }

  return user.roles?.includes(role) || false;
};


export const hasAnyRole = (user, roles = []) => {
  if (!user || !Array.isArray(roles)) {
    return false;
  }

  return roles.some((role) =>
    user.roles?.includes(role)
  );
};


export const isAdmin = (user) => {
  return hasRole(user, ROLES.ADMIN);
};


export const isSales = (user) => {
  return hasRole(user, ROLES.SALES);
};


export const isAgent = (user) => {
  return hasRole(user, ROLES.AGENT);
};


/*
|--------------------------------------------------------------------------
| MODULE PERMISSIONS
|--------------------------------------------------------------------------
|
| Define access permissions for each frontend module.
|
|--------------------------------------------------------------------------
*/


/*
|--------------------------------------------------------------------------
| USER MANAGEMENT
|--------------------------------------------------------------------------
|
| ADMIN only.
|--------------------------------------------------------------------------
*/

export const canAccessUsers = (user) => {
  return isAdmin(user);
};


/*
|--------------------------------------------------------------------------
| CATEGORY MANAGEMENT
|--------------------------------------------------------------------------
|
| ADMIN, SALES and AGENT can access categories.
|--------------------------------------------------------------------------
*/

export const canAccessCategories = (user) => {
  return hasAnyRole(user, [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.AGENT,
  ]);
};


/*
|--------------------------------------------------------------------------
| OFFERING MANAGEMENT
|--------------------------------------------------------------------------
|
| ADMIN, SALES and AGENT can access offerings.
|--------------------------------------------------------------------------
*/

export const canAccessOfferings = (user) => {
  return hasAnyRole(user, [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.AGENT,
  ]);
};


/*
|--------------------------------------------------------------------------
| OFFER MANAGEMENT
|--------------------------------------------------------------------------
|
| ADMIN, SALES and AGENT can access offers.
|--------------------------------------------------------------------------
*/

export const canAccessOffers = (user) => {
  return hasAnyRole(user, [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.AGENT,
  ]);
};


/*
|--------------------------------------------------------------------------
| PAYMENT MANAGEMENT
|--------------------------------------------------------------------------
|
| ADMIN, SALES and AGENT can access payments.
|--------------------------------------------------------------------------
|
| Payment management includes:
|
| - Payment list
| - Payment details
| - Payment monitoring
|
| Actual payment processing/verification remains
| controlled by the backend.
|--------------------------------------------------------------------------
*/

export const canAccessPayments = (user) => {
  return hasAnyRole(user, [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.AGENT,
  ]);
};


/*
|--------------------------------------------------------------------------
| GENERIC PERMISSION CHECK
|--------------------------------------------------------------------------
*/

export const canAccess = (user, allowedRoles = []) => {
  return hasAnyRole(user, allowedRoles);
};
